import { post } from '../../../redux/api';
import { queryClient, useMutation } from '../../../ReactQuery';
import { getTeamsQueryKey } from './useTeams';
import type { TeamWithAssociations } from '../../../../shared/types/routes/teams';
import { useTeamGroupsQueryKey } from './teamGroups/useTeamGroups';

type NewTeam = Pick<TeamWithAssociations, 'name' | 'defaultRoleId' | 'autoAddUsers' | 'uniqueIdentifier'> & {
  teamGroupIds?: number[] | null;
};

//  Function to create a team
function createTeam(team: NewTeam) {
  return post<NewTeam, TeamWithAssociations>('/api/teams', team);
}

/**
 * useCreateTeam is a hook that creates a team and invalidates the teams query.
 */
export default function useCreateTeam(newTeam: NewTeam) {
  return useMutation({
    mutationFn: () => createTeam(newTeam),
    onSuccess: () => {
      // First we add the new team to the cache, so that it appears immediately.
      queryClient.setQueryData(getTeamsQueryKey, (oldTeams: TeamWithAssociations[] | undefined) => {
        return [...(oldTeams ?? []), newTeam as TeamWithAssociations];
      });
      // Then we invalidate the teams query, so that the new full team data is fetched.
      queryClient.invalidateQueries(getTeamsQueryKey);
      // Team could have been added to a team group, so we invalidate the team groups query as well.
      queryClient.invalidateQueries(useTeamGroupsQueryKey);
    },
  });
}
